import React, { ReactNode } from 'react';
import styles from '../Fullscreen.module.scss';
import { useFullscreen } from '../useFullscreen';

type FullscreenNavbarProps = {
  children: ReactNode;
};
export const FullscreenNavbar = ({ children }: FullscreenNavbarProps) => {
  const fullscreen = useFullscreen();
  return <div className={styles.navbar}>{children}</div>;
};
